import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var mockAddress = {
  city: 'London',
  country: 'GB',
  line1: '123 Baker St',
  line2: 'Apt 4',
  postal_code: 'NW1 6XE',
  state: 'London'
};
var mockFirstName = 'Sherlock';
var mockLastName = 'Holmes';
var mockName = "".concat(mockFirstName, " ").concat(mockLastName);
var mockPhone = '07777777777';
var mockInvalidAddress = _objectSpread(_objectSpread({}, mockAddress), {}, {
  city: '∆ƒ∆∑'
});
var mockAddressDetails = {
  address: mockAddress,
  name: mockName
};
var mockBillingDetails = {
  address: mockAddress,
  name: mockName,
  phone: mockPhone
};
var mockPartialShippingDetails = {
  city: mockAddress.city,
  state: mockAddress.state,
  postal_code: mockAddress.postal_code.split('')[0],
  country: mockAddress.country
};
var mockInvalidBillingDetails = {
  address: mockInvalidAddress,
  name: mockName,
  phone: mockPhone
};
var mockInvalidShippingAddress = {
  address: mockInvalidAddress,
  name: mockName,
  phone: mockPhone
};
var mockInternationalShippingAddress = {
  address: _objectSpread(_objectSpread({}, mockAddress), {}, {
    country: 'US'
  }),
  name: mockName
};
var mockInvalidPartialShippingDetails = {
  city: '',
  state: mockAddress.state,
  postal_code: mockAddress.postal_code.split('')[0],
  country: mockAddress.country
};
export { mockAddress, mockAddressDetails, mockBillingDetails, mockFirstName, mockInternationalShippingAddress, mockInvalidAddress, mockInvalidBillingDetails, mockInvalidPartialShippingDetails, mockInvalidShippingAddress, mockLastName, mockName, mockPartialShippingDetails, mockPhone };